import React from 'react';
import InputData from "./InputData";

function SupervisorsInput({supervisors, setSupervisors, mode}) {
    function handleAddSupervisor() {
        setSupervisors([...supervisors, {EmployeeID: '-1', PhoneNo: ''}]);
    }

    function handleRemoveSupervisor(index) {
        setSupervisors(supervisors.filter((supervisor, i) => i !== index));
    }


    function handleSupervisorInputChange(event, index, key) {
        const {value} = event.target;
        setSupervisors(
            supervisors.map((supervisor, i) =>
                i === index ? {...supervisor, [key]: value} : supervisor
            )
        );
    }

    return (
        <>
            <div className="row">
                <div className='row'>
                <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="row title-supervisor">
                            <div className="col-lg-12 col-md-12 col-sm-12 subTitle">Phone Number*</div>
                        </div>
                    </div>
                    {
                        mode !== "add" && (
                            <>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="row title-supervisor">
                                        <div className="col-lg-12 col-md-12 col-sm-12 subTitle">Email</div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="row title-supervisor">
                                        <div className="col-lg-12 col-md-12 col-sm-12 subTitle">Supervisor</div>
                                    </div>
                                </div>
                            </>
                        )
                    }
                </div>
            </div>

            <InputData
                type="supervisor"
                data={supervisors}
                handleAdd={handleAddSupervisor}
                handleRemove={handleRemoveSupervisor}
                handleInputChange={handleSupervisorInputChange}
                mode={mode}
            />
        </>
    );
}

export default SupervisorsInput;